import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { useChat } from '../modules/ChatPane';
import { addEventListener, removeEventListenerByScope } from '../helpers/pubNubFunctions';

// Single tabs in the stream chat tab menu
// Renders the <li> and listens for messages on the
// associated channel to count notifications
export default function ChatTab({ tab, i }) {
  const {
    context: { content, selectedTab, isModerator, lastTab, multiMessageOptions },
    setContext,
  } = useChat();

  const channel = content.roomForChannelType(tab.data.channeltype);
  const [notificationCount, setNotificationCount] = useState(0);
  const selectTab = () => {
    setContext(old => {
      return {
        ...old,
        selectedTab: i,
        lastTab: selectedTab,
      };
    });
  };

  useEffect(() => {
    // if its the qa tab and moderate flow is on we want notifications for regular users
    // when a question is posted, not when a question is submitted
    if (tab.data.channeltype == OTSessionContent.CHANNELTYPE_QA && tab.data.moderateFlow && !isModerator) {
      addEventListener(
        PubNubCenter.ON_QA_POSTED,
        (event, data) => {
          if (data?.channel == channel && selectedTab !== i) {
            setNotificationCount(old => old + 1);
          }
        },
        'chat_tab_listeners',
      );
    } else {
      addEventListener(
        PubNubCenter.ON_MESSAGE,
        (event, data) => {
          if (data?.channel == channel && selectedTab !== i) {
            // raise hand should only notify moderators
            if (data?.message?.data?.modType === 'raise_hand' && !isModerator) {
              return;
            }
            setNotificationCount(old => old + 1);
          }
        },
        'chat_tab_listeners',
      );
    }

    return () => {
      if (tab.data.channeltype == OTSessionContent.CHANNELTYPE_QA && tab.data.moderateFlow && !isModerator) {
        removeEventListenerByScope(PubNubCenter.ON_QA_POSTED, 'chat_tab_listeners');
      } else {
        removeEventListenerByScope(PubNubCenter.ON_MESSAGE, 'chat_tab_listeners');
      }
      tab.data?.cohortChannels?.map((cohortChannel, i) => {
        removeEventListenerByScope(PubNubCenter.ON_MESSAGE, `chat_tab_listeners_${i}`);
      });
    };
  }, [selectedTab]);

  useEffect(() => {
    const allChatNotificationsAreClear = Object.values(multiMessageOptions).every(x => x.notification === false);

    // if leaving chat tab and there are still active message notifications - add tab notification
    if (lastTab == i && tab.data.channeltype == OTSessionContent.CHANNELTYPE_CHAT && !allChatNotificationsAreClear) {
      setNotificationCount(old => old + 1);
    }

    // When selecting a tab, clear notifications unless it is the chat tab and there are still active message notifications
    if (selectedTab == i) {
      if (tab.data.channeltype != OTSessionContent.CHANNELTYPE_CHAT) {
        setNotificationCount(0);
      } else if (allChatNotificationsAreClear) {
        setNotificationCount(0);
      }
    }
  }, [selectedTab, multiMessageOptions]);

  return (
    <li key={`chat_tab_${i}`}>
      <button
        className={`chat_tab`}
        onClick={selectTab}
        aria-label={`session chat panel - ${tab.name} tab`}
        tabIndex={0}
        style={{ border: 'none', background: 'none' }}
      >
        <div className={`tab_text`}>{tab.name != 'Visitors' ? tab.name : <i className="fa-solid fa-user-group" />}</div>
        {selectedTab == i && (
          <motion.div layoutId="tabs" className={`tab_indicator`} transition={spring} initial={false} />
        )}
        {notificationCount > 0 ? <div className={`notification_count`}></div> : <></>}
      </button>
    </li>
  );
}

const spring = {
  type: 'spring',
  stiffness: 500,
  damping: 30,
};
